import Button from '@components/Button/Button';
import Heading from '@components/Heading/Heading';
import styles from '@features/cms/components/collections/DesignersBlock/DesignersBlock.styles';
import sanitizeHtml from '@utils/sanitizeHtml';
type PropsType = {
  title: string;
  description: string;
  buttonText?: string;
  setIsModalOpen?: (isOpen: boolean) => void;
  isTeam?: boolean;
  fullContent?: boolean;
  withSmallTitle?: boolean;
  isFirst: boolean;
  email?: string;
  phone?: string;
};
const DesignerContent = ({
  title,
  description,
  buttonText = undefined,
  setIsModalOpen = undefined,
  isTeam = false,
  fullContent = false,
  withSmallTitle = false,
  isFirst,
  email = undefined,
  phone = undefined
}: PropsType) => <div sx={styles.designerContent(!!isTeam, !!fullContent && !!withSmallTitle)}>
    {withSmallTitle ? <Heading h={isFirst ? 1 : 2} headingType={2} pb={16} mobile>
        {title}
      </Heading> : <Heading h={isFirst ? 1 : 2} display={3} pb={16} mobile>
        {title}
      </Heading>}
    <div sx={styles.designerDescription(!!fullContent, !isTeam && !withSmallTitle)} dangerouslySetInnerHTML={sanitizeHtml(description)} />
    {buttonText && setIsModalOpen && <Button variant="outlined" variantColor="dark" size="small" letterCase="lowercase" onClick={() => setIsModalOpen(true)} data-testid="designer-content-button">
        {buttonText}
      </Button>}
    {(email || phone) && <div sx={styles.designerContact}>
        {email && <a href={`mailto:${email}`}>{email}</a>}
        {phone && <a href={`tel:${phone}`}>{phone}</a>}
      </div>}
  </div>;
export default DesignerContent;